import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SpinnerComponent } from './components/spinner.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    SpinnerComponent
  ],
  exports: [
    CommonModule,
    SpinnerComponent
  ]
})
export class SpinnerModule {}
